import {fetch} from "utils/dataAccess";

export async function getWmsItemsByRetailer(inventoryId) {
    const response = await fetch(`/w_m_s_items/new_grouped_by_retailer?inventoryId=${inventoryId}`);

    if (!response.ok) throw new Error('Failed to retrieve wms items');

    return await response.json();
}
